import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Giriş edilməyibsə login səhifəsinə yönləndir
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url }
  });
};

export const publicGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  // Artıq giriş edilibsə ana səhifəyə yönləndir
  return router.createUrlTree(['/']);
};
